<div class="container-fluid m-0 p-0">
    <div class="row">
        <div class="col-12 d-flex flex-wrap justify-content-between">
            <!-- <div class="col-12 d-flex flex-wrap justify-content-between" *ngIf="globals.checkUserHasPermission('COUNTRIES - CREATE')"> -->
            <button type="button" class="btn btn-success mb-2 mx-lg-0 mx-auto rounded-0"
                routerLink="/attendence/absence-request-create"><i class="fas fa-plus"></i> {{ "NEW_REQUEST" | translate
                |
                titlecase }}</button>
        </div>

        <div class="col-12">

            <div class="bg-white border pt-3 my-4">
                <h5 class="font-16 font-black px-3">{{ "AUTHORIZED_ABSENCE_REQUEST" | translate | titlecase }}</h5>
                <form [formGroup]="searchForm" (change)="searchFormChange()" (submit)="searchFormSubmit()">
                    <div class="row bg-white border m-0 py-3">
                        <div class="col-md-10 mx-md-auto py-3">
                            <div class="row">
                                <div class="col-md-4 form-group px-md-5 mb-4">
                                    <label class="font-bold">{{ "FILTER_BY" | translate | titlecase }}</label>
                                    <select class="form-control" formControlName="filterBy" (change)="getValues()">
                                        <!-- <option value="" >{{ "SELECT" | translate | titlecase
                                            }}
                                        </option> -->
                                        <option value="student">{{ "STUDENT" | translate | titlecase
                                            }}
                                        </option>
                                        <option value="status" [selected]="true">{{ "STATUS" | translate | titlecase
                                            }}
                                        </option>
                                        <!-- <option *ngFor="let field of years" [ngValue]="field.id">
                                        {{
                                        (globals.lang == 'ar')? field?.yearDescAr : field?.yearDescEn
                                        }}
                                    </option> -->
                                    </select>
                                    <div class="alert alert-danger py-1 mt-1"
                                        *ngIf="searchForm.controls.filterBy.touched && searchForm.controls.filterBy.invalid && searchForm.dirty">
                                        {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                    </div>
                                </div>
                                <div class="col-md-4 form-group px-md-5 mb-4" *ngIf="filterStatus">
                                    <label class="font-bold">{{ "VALUE" | translate | titlecase }}</label>
                                    <select class="form-control" formControlName="value">
                                        <option value="all" [selected]="true">{{ "ALL" | translate | titlecase
                                            }}
                                        </option>
                                        <option value="ma">{{ "MA" | translate | titlecase
                                            }}
                                        </option>
                                        <option value="aa">{{ "AA" | translate | titlecase
                                            }}
                                        </option>
                                        <option value="ua">{{ "UA" | translate | titlecase
                                            }}
                                        </option>
                                        <!-- <option *ngFor="let field of absTypes" [ngValue]="field.id">
                                            {{
                                            (globals.lang == 'ar')? field?.attNameAr : field?.attNameEn
                                            }}
                                        </option> -->
                                    </select>
                                    <div class="alert alert-danger py-1 mt-1"
                                        *ngIf="searchForm.controls.value.touched && searchForm.controls.value.invalid && searchForm.dirty">
                                        {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                    </div>
                                </div>

                                <div class="col-md-4 form-group px-md-5 mb-4" *ngIf="!filterStatus">
                                    <label class="font-bold">{{ "VALUE" | translate | titlecase }}</label>
                                    <select class="form-control" formControlName="value">
                                        <option value="all" >{{ "ALL" | translate | titlecase
                                            }}
                                        </option>
                                        <!-- <option value="ma">{{ "MA" | translate | titlecase
                                            }}
                                        </option>
                                        <option value="aa">{{ "AA" | translate | titlecase
                                            }}
                                        </option>
                                        <option value="ua">{{ "UA" | translate | titlecase
                                            }}
                                        </option> -->
                                        <option *ngFor="let field of students" [ngValue]="field.id">
                                            {{
                                            (globals.lang == 'ar')? field?.fullNameAr : field?.fullNameEn
                                            }}
                                        </option>
                                    </select>
                                    <div class="alert alert-danger py-1 mt-1"
                                        *ngIf="searchForm.controls.value.touched && searchForm.controls.value.invalid && searchForm.dirty">
                                        {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                    </div>
                                </div>
                                <div class="col-md-4 form-group px-md-5 mb-4" style="margin: auto;">
                                    <button type="submit" class="btn btn-primary m-2 rounded-0">
                                        {{ "APPLY" | translate | titlecase }}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <app-loader [show]="showLoader"></app-loader>
                <div class="table-responsive py-3" *ngIf="!showLoader && searched">
                    <table class="table-striped" id="datatable">
                        <thead>
                            <tr>
                                <th>{{ "ID" | translate | titlecase }}</th>
                                <th>{{ "TYPE" | translate | titlecase }}</th>
                                <th>{{ "STUDENT" | translate | titlecase }}</th>
                                <th>{{ "DATE_FROM" | translate | titlecase }}</th>
                                <th>{{ "DATE_TO" | translate | titlecase }}</th>
                                <th>{{ "REMARKS" | translate | titlecase }}</th>
                                <th>{{ "ATTACHMENT" | translate | titlecase }}</th>
                                <th>{{ "STATUS" | translate | titlecase }}</th>
                                <th class="border-0 font-14 px-2 text-grey">{{ "ASSIGNMENTS" | translate | titlecase
                                    }}</th>
                                <th class="border-0 font-14 px-2 text-grey">{{ "APPROVE" | translate | titlecase
                                    }}</th>
                                <th class="border-0 font-14 px-2 text-grey">{{ "REJECT" | translate | titlecase
                                    }}</th>
                                <th class="border-0 font-14 px-2 text-grey">{{ "STATUS_HISTORY" | translate | titlecase
                                    }}</th>
                                <th class="border-0 font-14 px-2 text-grey">{{ "MODIFY" | translate | titlecase }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let res of absenceRequests">
                                <td>{{res?.id}}</td>
                                <td>{{res?.requestTypeCode}}</td>
                                <td>{{res?.fullNameEn}}</td>
                                <td>{{res?.dateFrom}}</td>
                                <td>{{res?.dateTo}}</td>
                                <td>{{res?.remarks}}</td>
                                <td>{{res?.attachmentFilename}}</td>
                                <td>{{res?.statusFlag}}</td>
                                <td class="text-bold text-warning">
                                    <a class="btn btn-sm btn-link text-/success" routerLink="/attendence/absence-assignment" [queryParams]="{requestId: res?.id}">
                                        <!-- <i class="fas fa-thumbs-up"></i> -->
                                        <i class="fas fa-tasks"></i>
                                        {{ "ASSIGNMENTS" | translate | titlecase }}</a>
                                </td>
                                <td class="text-bold text-warning">
                                    <a class="btn btn-sm btn-link text-success" (click)="approveAbsenceRequest()"><i
                                            class="fas fa-thumbs-up"></i>
                                        {{ "APPROVE" | translate | titlecase }}</a>
                                </td>
                                <td class="text-bold text-warning">
                                    <a class="btn btn-sm btn-link text-danger" (click)="rejectAbsenceRequest()"><i
                                            class="fas fa-ban"></i>
                                        {{ "REJECT" | translate | titlecase }}</a>
                                </td>
                                <td class="text-bold text-warning">
                                    <a class="btn btn-sm btn-link text-grey" (click)="showStatusHistory()">
                                        <i class="fas fa-search"></i>
                                        {{ "HISTORY" | translate | titlecase }}</a>
                                </td>
                                <td class="text-bold text-warning">
                                    <a class="btn btn-sm btn-link" routerLink="/attendence/absence-request-update" [queryParams]="{requestId: res?.id}" *ngIf="res?.statusFlag == 'DRAFT'">
                                        <i class="fas fa-edit"></i>
                                        {{ "MODIFY" | translate | titlecase }}</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>